import * as z from "../../../../framework";
import Map from "../../map/map";
import { Widget } from "./widget";

// tslint:disable-next-line:variable-name
export var W_Map = function (widgetInstance?) {
    let me = this;
    widgetInstance = widgetInstance || {};

    let parent = widgetInstance.Widget;
    if (parent) {
        me.title = parent.WidgetName;

        let optionsString = parent.Options || "";
        let options = me.parse(optionsString) || {};

        me.markerTypes = options.markerTypes || [];
        me.height = options.height || 500;
        me.distinctFaultCodes = options.distinctFaultCodes || false;

        me.defaultLatitude = (options.latitude && options.latitude >= -90 && options.latitude <= 90)
            ? options.latitude
            : z.user.companyData.Settings.Latitude || 43.0500;

        me.defaultLongitude = (options.longitude && options.longitude >= -180 && options.longitude <= 180)
            ? options.longitude
            : z.user.companyData.Settings.Longitude || -87.9500;

        me.defaultMapLocation = [me.defaultLatitude, me.defaultLongitude];

        me.defaultZoom = (options.zoom && options.zoom >= 0 && options.zoom <= 20)
            ? options.zoom
            : 10;
    }

    me.availableColors = [
        "red",
        "gray",
        "pink",
        "orange",
        "darkgrey",
        "black"
    ];

    let widget = new Widget(widgetInstance);
    $.extend(this, widget);

    this.init();
};

W_Map.prototype = {
    init: function () {
        let me = this;

        me.initHtml();
        me.initMapLayers();
        me.defaultMap();
    },
    initHtml: function () {
        let me = this;

        me.contents.append(
            `<div id=\"MapViewContainer\" class=\"k-pane\">
                <div id=\"${me.id}_Map\" class=\"widget-map\" style='width: 100%; height: ${me.height}px;'></div>
            </div>`);
    },
    initMapLayers: function () {
        let me = this,
            mapElement = me.contents.find(".widget-map"),
            markerLayers = [];

        if (me.distinctFaultCodes) {
            markerLayers.push({
                label: "Equipment",
                type: "equipment"
            });
        }

        me.map = new Map({
            id: mapElement[0].id,
            markerLayers: markerLayers
        });

        if (me.distinctFaultCodes) {
            me.contents.mask();
            me.buildDistinctFaultCodesLayer();
        }
    },
    parse: function (input) {
        try {
            return JSON.parse(input);
        } catch (e) {
            if (window.z.debuggerAttached) {
                console.log(e.message);
            }

            return null;
        }
    },
    buildDistinctFaultCodesLayer: function () {
        let me = this;

        let expand = [
            "EquipmentMeter",
            "EquipmentMeter/Equipment",
            "EquipmentMeter/Equipment/Inventory"
        ].join(",");

        let select = [
            "Reading",
            "EquipmentMeter/EquipmentMeterNumber",
            "EquipmentMeter/Equipment/Latitude",
            "EquipmentMeter/Equipment/Longitude",
            "EquipmentMeter/Equipment/EquipmentNumber",
            "EquipmentMeter/Equipment/Serial",
            "EquipmentMeter/Equipment/Inventory/InventoryNumber"
        ].join(",");

        let odataQuery = `?$expand=${expand}&$select=${select}`;
        let filter = "&$filter=EquipmentMeter/EquipmentMeterNumber eq 'FAULT'&$top=10000";
        let url = `EquipmentMeterReading/Latest${odataQuery}${filter}`;

        z.ajax({
            url : url
        }).done(function (result) {
            $.each(result.d.results, function (index, reading) {
                let meter = reading.EquipmentMeter;
                let equipment = meter.Equipment;
                let inventory = equipment.Inventory;

                if (reading.Reading <= 0) {
                    return true;
                }

                me.map.addMarker("Equipment", {
                    latitude : equipment.Latitude,
                    longitude : equipment.Longitude,
                    className: `map-marker equipment-marker ${me.getFaultColor(reading.Reading)}`,
                    popUpHTML: `<div>${z.ll("InventoryNumber")}: ${(inventory ? inventory.InventoryNumber : "---")}</div>` +
                        `<div>${z.ll("EquipmentNumber")}: ${(equipment.EquipmentNumber || "---")}</div>` +
                        `<div>${z.ll("SerialNumber")}: ${(equipment.Serial || "---")}</div>` +
                        `<div>${z.ll("FaultCode")}: ${reading.Reading}</div>`
                });

                // ReSharper disable once NotAllPathsReturnValue
            });
        }).done(function () {
            me.contents.unmask();
        });
    },
    getFaultColor: function (faultCode) {
        let me = this;
        me.faultColorMapping = me.faultColorMapping || {};

        let faultColor = me[faultCode];
        if (faultColor) {
            return faultColor;
        }

        if (me.availableColors.length > 0) {
            let newFaultColor = me.availableColors[0];

            me.faultColorMapping[faultCode] = newFaultColor;
            me.availableColors.splice(0, 1);

            return newFaultColor;
        } else {
            return "";
        }

    },
    defaultMap: function () {
        let me = this;

        me.map.leafletMap.setView(me.defaultMapLocation, me.defaultZoom);
    }
};
